import {Injectable} from '@angular/core';
import sdk from "@sp400/sdk"
import {SpaceConfig} from "@sp400/core/src/types/space";

@Injectable({
  providedIn: 'root'
})
export class SdkService {
  JeepNaftaPrep: SpaceConfig = {
    monitoring: 'LOW',
    credentials: {
      //apiKey: "4_XXpeiZQvSU8oos3X7unsCA",
      apiKey: "4_i1D51Xc3_eH_cQ83APWjOg",
      enableCLP: false,
      fcaCognito: {
          getCognitoIdentityToken: {
              'path': '/v2/cognito/identity/token',
              'method': 'POST',
              'host': "https://authz.sdpr-02.intg.fcagcv.com",
              'headers': {
                  'Content-Type': 'application/json',
                  'x-api-key': 'KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7',
                  'locale': 'us_en',
                  'region': "us-east-1",
                  'x-originator-type': 'web',
                  'x-clientapp-version': '1.0',
              }
          },
          cognito_sdpr_params: {
              'fcl_api_host': "https://mfa.fcl-02.intg.fcagcv.com",
              'fcl_api_key': "0QV5V9Qi1R2OFIjCLPBPIat1gSqOXYuc52eqF1jy",
              'identity_token_path': "/v2/cognito/identity/token",
              'lambda_function_api_key': "KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7",
              'lambda_function_base_url': "https://authz.sdpr-02.intg.fcagcv.com",
              'mqtt_host': "ahxm540mrkftr-ats.iot.us-east-1.amazonaws.com",
              'region': "us-east-1",
              'sdpr_sign_service': "execute-api",
              'sdpr_api_key': "KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7",
              'sdpr_api_key_disclaimer': "KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7",
              'sdpr_api_host': "https://channels.sdpr-02.intg.fcagcv.com",
              'version': "v1",
              'x_originator_type': "web",
          },
          spaceMWUrl: "https://api-web-integ.space.awsmpsa.com"
      }
  },
    brand: 'jeep',
    appVersion: '1',
    countryCode: 'us',
    language: 'en'
};
 /* JeepPrep: SpaceConfig = {
    monitoring: 'HIGH',
    credentials: {
      // apiKey: "3_NXVewKiQFESynTTjzlZti99EWsdWy-9Pcs64QYRYnDFRNrnMvU3xTv2T5Z5QOIWi", //fiat
      // apiKey: "3_Hk0isl\u002DWrBb42e_Awydf1BtG\u002Dkg2PgHogOHv_LJ4PSuewa8LB3GWLOkL8A3xAJar",
      apiKey: "3_Hk0isl-WrBb42e_Awydf1BtG-kg2PgHogOHv_LJ4PSuewa8LB3GWLOkL8A3xAJar",
      // apiKey: "4_XXpeiZQvSU8oos3X7unsCA", // Fleet Dev
      enableCLP: false,
      fcaCognito: {
        getCognitoIdentityToken: {
          'path': '/v2/cognito/identity/token',
          'method': 'POST',
          'host': 'https://authz.sdpr-01.prep.fcagcv.com',
          'headers': {
            'Content-Type': 'application/json',
            'x-api-key': '22TW1MzCYY67w2YDNwLU053cfZFVvMwX6C2jiGa2',
            'locale': 'gb_en',
            'region': "eu-west-1",
            'x-originator-type': 'web',
            'x-clientapp-version': '1.0',
          }
        },
        cognito_sdpr_params: {
          'fcl_api_host': "https://mfa.fcl-01.prep.fcagcv.com",
          'fcl_api_key': "GWLujnWpm47yh4cVgWOGW7vZGgCZXGap2Y5yI56Z",
          'identity_token_path': "/v2/cognito/identity/token",
          'lambda_function_api_key': "22TW1MzCYY67w2YDNwLU053cfZFVvMwX6C2jiGa2",
          'lambda_function_base_url': "https://authz.sdpr-01.prep.fcagcv.com",
          'mqtt_host': "a15uoo35ocazd7-ats.iot.eu-west-1.amazonaws.com",
          'region': "eu-west-1",
          'sdpr_api_host': "https://channels.sdpr-01.prep.fcagcv.com",
          'sdpr_api_key': "22TW1MzCYY67w2YDNwLU053cfZFVvMwX6C2jiGa2",
          'sdpr_api_key_disclaimer': "22TW1MzCYY67w2YDNwLU053cfZFVvMwX6C2jiGa2",
          'sdpr_sign_service': "execute-api",
          'version': "v1",
          'x_originator_type': "web",
        },
        spaceMWUrl: "https://api-web-preprod.space.awsmpsa.com"
      }
    },
    brand: 'jeep',
    appVersion: '1',
    countryCode: 'gb',
    language: 'en'
  };
  /*JeepPrepNew: SpaceConfig = {
    monitoring: 'LOW',
    credentials: {
      // apiKey: "3_NXVewKiQFESynTTjzlZti99EWsdWy-9Pcs64QYRYnDFRNrnMvU3xTv2T5Z5QOIWi", //fiat
      apiKey: "4_XXpeiZQvSU8oos3X7unsCA",
      enableCLP: false,
      fcaCognito: {
        getCognitoIdentityToken: {
          'path': '/v2/cognito/identity/token',
          'method': 'POST',
          'host': "https://authz.sdpr-02.intg.fcagcv.com",
          'headers': {
            'Content-Type': 'application/json',
            'x-api-key': 'KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7',
            'locale': 'us_en',
            'region': "us-east-1",
            'x-originator-type': 'web',
            'x-clientapp-version': '1.0',
          }
        },
        cognito_sdpr_params: {
          'fcl_api_host': "https://mfa.fcl-02.intg.fcagcv.com",
          'fcl_api_key': "0QV5V9Qi1R2OFIjCLPBPIat1gSqOXYuc52eqF1jy",
          'identity_token_path': "/v2/cognito/identity/token",
          'lambda_function_api_key': "KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7",
          'lambda_function_base_url': "https://authz.sdpr-02.intg.fcagcv.com",
          'mqtt_host': "ahxm540mrkftr-ats.iot.us-east-1.amazonaws.com",
          'region': "us-east-1",
          'sdpr_sign_service': "execute-api",
          'sdpr_api_key': "KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7",
          'sdpr_api_key_disclaimer': "KSgZqZQxsh8gw5cSTaDmn6xfMBo33oy03pCCZmz7",
          'sdpr_api_host': "https://channels.sdpr-02.intg.fcagcv.com",
          'version': "v1",
          'x_originator_type': "web",
        },
        spaceMWUrl: "https://api-web-integ.space.awsmpsa.com"
      }
    },
    brand: 'jeep',
    appVersion: '1',
    countryCode: 'us',
    language: 'en'
  };

  JeepPrep: SpaceConfig = {
    monitoring: 'HIGH',
    credentials: {
      //apiKey: "3_HQZNOHJHHJg65kbP0XPpvObXLPgw4OzkZ3thj0JWSz_VrKXEpKd\u002Dtiqfbk6zmER1",
      apiKey: "3_NbPN_XKKo_dgtpw-qRPWncCEtYGP7sinSvajTIe7i4ZIedsPICMXPX_7wRXF18LW",
      enableCLP: false,
      fcaCognito: {
        getCognitoIdentityToken: {
          'path': '/v2/cognito/identity/token',
          'method': 'POST',
          'host': "https://authz.sdpr-02.prep.fcagcv.com",
          'headers': {
            'Content-Type': 'application/json',
            'x-api-key': '2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B',
            'locale': 'us_en',
            'region': "us-east-1",
            'x-originator-type': 'web',
            'x-clientapp-version': '1.0',
          }
        },
        cognito_sdpr_params: {
          'fcl_api_host': "https://mfa.fcl-02.prep.fcagcv.com",
          'fcl_api_key': "lHBEtsqT1Y5oKvzhvA9KW6rkirU3ZtGf44jTIiQV",
          'identity_token_path': "/v2/cognito/identity/token",
          'lambda_function_api_key': "2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B",
          'lambda_function_base_url': "https://authz.sdpr-02.prep.fcagcv.com",
          'mqtt_host': "agz8346qrixdz-ats.iot.us-east-1.amazonaws.com",
          'region': "us-east-1",
          'sdpr_sign_service': "execute-api",
          'sdpr_api_key': "2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B",
          'sdpr_api_key_disclaimer': "2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B",
          'sdpr_api_host': "https://channels.sdpr-02.prep.fcagcv.com",
          'version': "v1",
          'x_originator_type': "web",
        },
        spaceMWUrl: "https://api-web-preprod.space.awsmpsa.com"
      }
    },
    brand: 'jeep',
    appVersion: '1',
    countryCode: 'us',
    language: 'en',
    source: "SPACEWEB"
  };*/

  constructor() {
  }

  async initializeSDK(): Promise<boolean> {
    localStorage.setItem('SpaceSDKConfiguration', JSON.stringify({
      env: "intg",
      source: "omni",
      gigya_api_key: this.JeepNaftaPrep && this.JeepNaftaPrep.credentials && this.JeepNaftaPrep.credentials.apiKey ? this.JeepNaftaPrep.credentials.apiKey : "", // "3_xSF8rYIXw_7oO0MGwMaBaCjmfMkT5z0RmPh-7Tk_42c0Tpm7Wyynulx8OKpZksGD",
      brand: this.JeepNaftaPrep.brand,
      country: this.JeepNaftaPrep.countryCode,
      language: this.JeepNaftaPrep.language
    }));

    localStorage.setItem('SpaceMonitoring', this.JeepNaftaPrep.monitoring + "");

    return sdk.initialize(this.JeepNaftaPrep);
  }

  isInitialized(): Promise<boolean> {
    return sdk.isReady();
  }
}